<div class="row ml-1 mt-2">
  <div class="col">
    <small>
      <a [routerLink]="['/provider/dashboard']" class="text-secondary pointer">Admin Console</a>
      &nbsp;/&nbsp;<a class="text-secondary pointer" [routerLink]="['/provider/user-roles']"
        (click)="closeUserView()">User Roles</a>
    </small>
    <small *ngIf="isViewUser">
      &nbsp;/&nbsp;<a class="text-secondary">{{utilService.selectedAccountUser.name}}</a>
    </small>
  </div>
</div>

<div *ngIf="!isViewUser" class="row pt-2">
  <!--Invite User button-->
  <div class="col-sm-12">
    <button type="button" class="btn btn-primary float-right" data-toggle="modal" data-target="#addAdmin"
      data-backdrop="static" data-keyboard="false">Add User
      <!-- &nbsp;<span><i class="fas fa-chevron-right"></i></span> -->
    </button>
  </div>

  <!--User list template-->
  <div class="col-sm-12 mt-3 pb-3">
    <app-user-list [admins]="admins" (deleteUsersEmitter)="onDeleteAdmins($event)"
      (viewUserDetailEmitter)="onViewUser()" #userListTemplate></app-user-list>
  </div>
</div>

<div *ngIf="isViewUser" class="row pt-2">
  <div class="col-12">
    <app-view-user-detail (onCloseViewEmitter)="closeUserView()" (onActivateUserEmitter)="activateUser($event)"
      (onDeactivateUserEmitter)="deactivateUser($event)" (onResendInviteEmitter)="resendInvite($event)"
      (onUpdateUserRoleEmitter)="onUpdateUserRole($event)" (onResetUserPasswordEmitter)="resetUserPassword($event)"
      #userDetailTemplate></app-view-user-detail>
  </div>
</div>

<!-- Invite User -->
<app-invite-user [userRoles]="userRoles" (onCreateAdminEmitter)="addUsersByRole($event)" #inviteUserTemplate>
</app-invite-user>